export default __webpack_public_path__ + "static/media/incr_JS.dd044870.PNG";